import { useVeiculosCombo } from "@/features/veiculos/hooks/useVeiculos";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NENHUM = "__none__";

interface Props {
  value?: number;
  onChange: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
}

/** Seletor do cadastro de veículos (placa — modelo), no lugar de digitar o ID. */
export function VeiculoSelect({ value, onChange, placeholder = "Selecione o veículo", disabled }: Props) {
  const { data: veiculos = [], isLoading } = useVeiculosCombo();

  return (
    <Select
      value={value ? String(value) : NENHUM}
      onValueChange={(v) => onChange(v === NENHUM ? undefined : Number(v))}
      disabled={disabled}
    >
      <SelectTrigger><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NENHUM}>{isLoading ? "Carregando…" : placeholder}</SelectItem>
        {veiculos.map((v) => (
          <SelectItem key={v.id} value={String(v.id)}>
            {[v.placa, v.modelo].filter(Boolean).join(" — ") || `Veículo ${v.id}`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
